export default __webpack_public_path__ + "static/media/back.4d308535.jpg";